(function () {
    "use strict";

    // @ngInject
    function DownloadReportServiceCtor(ReportsManager, moment, WorkspacesManager, PendingTasksManager) {
        this.ReportsManager = ReportsManager;
        this.WorkspacesManager = WorkspacesManager;
        this.moment = moment;
        this.PendingTasksManager = PendingTasksManager;
    }

    Services.DownloadReportService = Class(function () {


        return {

            constructor: DownloadReportServiceCtor,

            getSummaryReport: function (args) {

                var userId = args.userId;
                var fixedStartDate = args.startDate;
                var fixedEndDate = args.endDate;
                var datesFormat = args.dateFormat;
                if (datesFormat === 'MMM DD, YYYY') {
                    fixedStartDate = this.moment(fixedStartDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
                    fixedEndDate = this.moment(fixedEndDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
                }
                return this.ReportsManager.downloadEventReportAsCSV(userId, fixedStartDate, fixedEndDate);
            },

            getLeadsReport: function (args) {

                var userId = args.userId;
                var fixedStartDate = args.startDate;
                var fixedEndDate = args.endDate;
                var datesFormat = args.dateFormat;
                if (datesFormat === 'MMM DD, YYYY') {
                    fixedStartDate = this.moment(fixedStartDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
                    fixedEndDate = this.moment(fixedEndDate, 'MMM DD, YYYY').format('DD/MM/YYYY');
                }
                return this.ReportsManager.downloadLeadsReportAsCSV(userId, fixedStartDate, fixedEndDate);
            },

            getAnnualReport: function (args) {
                var self = this;
                var taskData = {
                    user_id: args.userId,
                    year: args.year,
                    report_type: 'annual_report'
                };

                //we save the promise so that the polling could be canceled once we destroy the button. the promise is the token to stop the polling
                self.pendingTaskPromise = self.PendingTasksManager.createPendingTask(self.PendingTasksManager.pendingTasksTypes.generateReport, taskData);
                return self.pendingTaskPromise.then(
                    function success(resp) {
                        return resp;
                    })
                    .catch(function fail(resp) {
                        return null;
                    });
            },

            getMonthlyReport: function (args) {
                var userId = args.userId;
                var month = args.month;
                var toFormat = args.toFormat;
                month = this.moment(month).format(toFormat);
                return this.ReportsManager.downloadMonthlyReport(userId, month);
            },

            getArchivedWorkspacesReport: function (args) {
                // var userId = args.userId;
                return this.WorkspacesManager.getArchiveWorkspacesReport();
            },

            getConnectionsReport: function (args) {
                var self = this;
                var taskData = {
                    user_id: args.userId,
                    report_type: 'connections_report'
                };

                //we save the promise so that the polling could be canceled once we destroy the button. the promise is the token to stop the polling
                self.pendingTaskPromise = self.PendingTasksManager.createPendingTask(self.PendingTasksManager.pendingTasksTypes.generateReport, taskData);
                return self.pendingTaskPromise.then(
                    function success(resp) {
                        return resp;
                    })
                    .catch(function fail(resp) {
                        return null;
                    });
            },
        };
    });
}());